import { FACULTY_APP_URL } from "@src/app/faculties/FacultyLinks";
import { QUALIFICATION_APP_URL } from "@src/app/qualifications/QualificationLinks";
import { STUDY_APP_URL } from "@src/app/studies/StudyLinks";
import { GROUP_APP_URL } from "@src/app/types/GroupLinks";
import { MODULE_APP_URL } from "@src/app/types/ModuleLinks";
import { Product, ProductTypeEnum } from "@src/app/types/Product";

export type ProductTypesWithDetailPages =
  | ProductTypeEnum.GROUP
  | ProductTypeEnum.FACULTY
  | ProductTypeEnum.MODULE
  | ProductTypeEnum.QUALIFICATION
  | ProductTypeEnum.STUDY;

export const PRODUCT_DETAIL_URLS = {
  FACULTY: `${FACULTY_APP_URL}/:code`,
  GROUP: `${GROUP_APP_URL}/:code`,
  MODULE: `${MODULE_APP_URL}/:code`,
  QUALIFICATION: `${QUALIFICATION_APP_URL}/:code`,
  STUDY: `${STUDY_APP_URL}/:code`
};

export const productDetailConfigMap: Record<
  ProductTypesWithDetailPages,
  { url: string; defaultMainTab: string }
> = {
  [ProductTypeEnum.FACULTY]: {
    url: PRODUCT_DETAIL_URLS.FACULTY,
    defaultMainTab: "faculty"
  },
  [ProductTypeEnum.GROUP]: {
    url: PRODUCT_DETAIL_URLS.GROUP,
    defaultMainTab: "group"
  },
  [ProductTypeEnum.MODULE]: {
    url: PRODUCT_DETAIL_URLS.MODULE,
    defaultMainTab: "module"
  },
  [ProductTypeEnum.QUALIFICATION]: {
    url: PRODUCT_DETAIL_URLS.QUALIFICATION,
    defaultMainTab: "qualification"
  },
  [ProductTypeEnum.STUDY]: {
    url: PRODUCT_DETAIL_URLS.STUDY,
    defaultMainTab: "study"
  }
};

export function isProductTypeWithDetailPage(
  product?: Product
): product is Product & { productType: ProductTypesWithDetailPages } {
  return !!product && product.productType in productDetailConfigMap;
}
